import { render } from "./BreakoutRoomsEditor.vue?vue&type=template&id=6035e591&scoped=true"
import script from "./BreakoutRoomsEditor.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsEditor.vue?vue&type=script&lang=js"

import "./BreakoutRoomsEditor.vue?vue&type=style&index=0&id=6035e591&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6035e591"]])

export default __exports__